import * as React from 'react';
import { cn } from '../../../utils/ClassNamesUtils';
import { useOscarTheme } from '../../context/OscarRoleContext';

interface OscarSuggestionChipProps {
	label: string;
	onClick?: () => void;
	disabled?: boolean;
	className?: string;
}

/**
 * Full-width starter prompt in the Oscar empty state.
 *
 * Figma draws the fill as purple/1 @ 50%, which composites over white to
 * #fcf7ff — exactly the BG FILL the design guideline asks to be tokenised, so
 * this uses that token directly. Stroke is the role accent at 2px per the
 * guideline (Figma's own node said 0.5px).
 */
export const OscarSuggestionChip = ({
	label,
	onClick,
	disabled,
	className,
}: OscarSuggestionChipProps) => {
	const theme = useOscarTheme();
	return (
		<button
			type="button"
			disabled={disabled}
			onClick={onClick}
			className={cn(
				'h5regular flex w-full cursor-pointer items-center rounded px-xs py-xs text-left text-grey-9 transition-colors',
				theme.surface,
				theme.stroke,
				!disabled && theme.surfaceHover,
				disabled && 'cursor-not-allowed opacity-50',
				className
			)}
		>
			{label}
		</button>
	);
};

export default OscarSuggestionChip;
